export default "__VITE_ASSET__CtpyYylA__"